/* eslint-disable camelcase */
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getSESProductQtyChanges = (query) => {
  const { itemsPerPage, currentPage, sortBy, sortOrder, keyword, product_code } = query;
  const itemOffset = (currentPage - 1) * itemsPerPage;
  
  // let queryString = `&limit=${itemsPerPage || 10}&skip=${itemOffset || 0}`;
  let queryString = `&limit=${1000}&skip=${itemOffset || 0}`;

  if (sortBy) {
    const sortDirection = sortOrder < 0 ? '-' : '';
    queryString += `&sort=${sortDirection}${sortBy}`;
  }
  
  if (keyword) {
    queryString += `&keyword=${keyword}`;
  }

  if (product_code) {
    queryString += `&product_code=${product_code}`;
  }

  return API.get(`${getApiUrl()}/api/ses-product-qty-change?${queryString}`);
};

export const setSESProductQtyChanges = (data, query = {}) => {
    console.log("data", data);
    return API.post(`${getApiUrl()}/api/ses-product-qty-change`, data);
};

export const sesProductQtyChangeService = {
  getSESProductQtyChanges,
  setSESProductQtyChanges
}; 